// extracted by mini-css-extract-plugin
module.exports = {"loading":"Loading_loading__2mWih"};